module.exports = __webpack_public_path__ + "files/0bc7c93981828cfb58f1ddca76dbef22.png";